import { supabase } from './supabase'

// Open requests for the public board and the home page strip. Comes from the
// wanted_board database function (sql/2026-11-03-wanted-board-first-names.sql),
// which sends the poster's first name only (never the full name) and a
// rounded distance instead of coordinates. Nearest first when lat/lng given.
export async function fetchWantedBoard({ lat = null, lng = null, limit = 300 } = {}) {
  const { data, error } = await supabase.rpc('wanted_board', { p_lat: lat, p_lng: lng, p_limit: limit })
  if (error) throw error
  return data || []
}
